import { BladeDamagesRepository } from "@/api/Repositories";

export default {
  namespaced: true,
  state: {
    list: [],
    images: []
  },
  mutations: {
    list (state, data) {
      state.list = []
      state.list = data
    },
    images (state, data) {
      state.images = []
      state.images = data
    },
  },
  actions: {
    list ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        BladeDamagesRepository.getAll(obj)
          .then(response => {
            const data = response.data.data
            for (let i = 0; i < data.length; i++) {
              const element = data[i]
              const name = [
                element.wind_turbine,
                element.location,
                element.blade_damage_type.name,
                element.severity,
              ]
              element.name = name.join(' - ')
              element.option = element.id
            }
            commit('list', data)
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    get (context, obj) {
      return new Promise((resolve, reject) => {
        BladeDamagesRepository.get(obj)
          .then((response) => {
            resolve(response);
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    create (context, obj) {
      return new Promise((resolve, reject) => {
        BladeDamagesRepository.create(obj)
          .then((response) => {
            resolve(response);
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    edit (context, obj) {      
      return new Promise((resolve, reject) => {
        BladeDamagesRepository.update(obj)
          .then(() => {
            resolve();
          }).catch(errorEdit => {
            reject(errorEdit);
          });
      });
    },
    delete (context, obj) {
      return new Promise((resolve, reject) => {
        BladeDamagesRepository.delete(obj)
          .then(() => {
            resolve();
          })
          .catch(errorDelete => {
            reject(errorDelete);
          });
      });
    },
    images ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        BladeDamagesRepository.get(obj)
          .then(response => {
            const data = response.data.data.damage_images
            commit('images', data)
            resolve(response);
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    uploadFile (context, upload) {
      const formData = new FormData();
      formData.append('blade_damage_image', upload.fileToUpload)
      formData.append('type', upload.type)
      upload.file = formData

      return new Promise((resolve, reject) => {
        BladeDamagesRepository.uploadFile(upload)
          .then(() => {
            resolve();
          }).catch(errorDeleteFile => {
            reject(errorDeleteFile);
          });
      });
    },
    deleteFile (context, file) {
      return new Promise((resolve, reject) => {
        BladeDamagesRepository.deleteFile(file)
          .then(() => {
            resolve();
          }).catch(errorDeleteFile => {
            reject(errorDeleteFile);
          });
      });
    },
  }
}
